const getters = {
  sidebar: state => state.app.sidebar,
  user_id: state => state.user.user_id,
  username: state => state.user.username,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js